import './styles/common';
import $ from 'jquery';
import './images/footer-social-fb.png';
import './images/footer-social-gplus.png';
import './images/footer-social-tw.png';
import './images/footer-social-yt.png';

import './images/474352257.png';
import './images/egypt-piramida.png';
import './images/work-in-company.jpg';

import './images/health-feature-first.png';
import './images/health-feature-second.png';
import './images/health-feature-third.png';

import Barba from 'barba.js';

import Menu from './scripts/menu';

import { addJqPlugin, transitionCss, imgLoaded } from './scripts/helper'
addJqPlugin('transitionCss', transitionCss);

let menu;
const $win = $(window);
const $doc = $(document);
const $html = $('html');
const $body = $('body');
const $htmlBody = $('html, body');

menu = Menu.of($('.main-menu'));

let isFirst = true;

const transition = Barba.BaseTransition.extend({
    start() {
        isFirst = false;
        Promise
            .all([this.newContainerLoading, this.fadeOut()])
            .then(() => {
                let waitImgSrc = $(this.newContainer).find('[data-wait]').attr('data-wait');
                imgLoaded(waitImgSrc).then(this.fadeIn.bind(this));
            });
    },
    fadeOut() {
        // console.log('out')
        $(this.oldContainer).css({position: 'absolute', top: -1 * $win.scrollTop(), left: 0, right: 0, 'z-index': -1});
        $win.scrollTop(0);
        return new Promise(function (resolve) {
            if (menu.active) {
                menu.close().then(resolve);
            } else {
                resolve();
            }
            menu.destroy();
        });
    },
    fadeIn() {
        // console.log('in')
        let isSameNamespace = Barba.HistoryManager.prevStatus().namespace === Barba.HistoryManager.currentStatus().namespace;
        let $newContainer = $(this.newContainer);
        let $newHeader = $newContainer.find('.header').css({transition: 'none', opacity: 0});
        let $newMain = $newContainer.find('.barba-main').css({transition: 'none', transform: 'translateY(100vh)'});
        if (isSameNamespace) {
            var $oldSecondMenu =  $(this.oldContainer).find('.page-menu');
            var $newSecondMenu = $newMain.find('.page-menu').css({transition: 'none', opacity: 0});
            var $newSecondMenuClone = $newSecondMenu.clone().css({position: 'fixed', marginTop: 0, left: 0, right: 0, top: $newHeader.outerHeight() + 'px'}).appendTo($body);
        }
        $newContainer.css('visibility', '').addClass('barba-fade-in-container');
        setTimeout(() => {
            $newMain.transitionCss(() => {
                $newHeader.css({transition: 'opacity 0.5s', opacity:1});
                $newMain.css({transition: 'transform 0.7s', transform: 'translateY(0)'});
                if (isSameNamespace) {
                    $oldSecondMenu.css({transition: 'opacity 0.5s', opacity: 0});
                    $newSecondMenuClone.css({transition: 'opacity 0.5s', opacity: 1});
                }
            }).then(() => {
                $newHeader.css({transition: '', opacity: ''});
                $newMain.css({transition: '', transform: ''});
                if (isSameNamespace) {
                    $newSecondMenu.css({transition: '', opacity: ''});
                    $newSecondMenuClone.remove();
                }
                $newContainer.removeClass('barba-fade-in-container');
                this.done()
            });
            menu = Menu.of($('.main-menu', $newContainer));
        }, 10);
    }
});

Barba.Pjax.getTransition = () => {
    return transition;
};
// Barba.Prefetch.init();
Barba.Pjax.start({
    ignoreFiles: ['pdf', 'doc', 'exe', 'dmg']
});


Barba.Dispatcher.on('newPageReady', (currentStatus, oldStatus, container, newPageRawHTML) => {
    const $newPageScripts = $('<div />').html(
        $.parseHTML(
            newPageRawHTML.match(/<div class="page-scripts">([\s\S]*?)<\/div>/i)[0],
            document,
            true
        )
    );

    const $newPageHead = $('<head />').html(
        $.parseHTML(
            newPageRawHTML.match(/<head[^>]*>([\s\S.]*)<\/head>/i)[0], document, true
        )
    );
    const headTags = [
        "meta[name='keywords']",
        "meta[name='description']",
        "meta[property^='og']",
        "meta[name^='twitter']",
        "meta[itemprop]",
        /*"link[data-style]",*/
    ].join(',');

    $('head').find(headTags).remove();
    $newPageHead.find(headTags + ', link[data-style]').appendTo('head');
    $body.removeClass('menu-is-active');

    $('.page-scripts', $body).empty().html($newPageScripts.find('.page-scripts').html());
});

// Barba.Dispatcher.on('transitionCompleted', (currentStatus, prevStatus) => {
// });
export {
    $win,
    $doc,
    $html,
    $body,
    $htmlBody,
    isFirst
}



// WEBPACK FOOTER //
// ./common.js